var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('p',[_vm._v("© "),_c('a',{attrs:{"href":_vm.url}},[_vm._v("Robin Hamill")]),_vm._v(" "+_vm._s(_vm.currentYear)+" | All rights reserved.")])])}
var staticRenderFns = []

export { render, staticRenderFns }